import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconWebstorm({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="m10.2 0 3.725.325.789 1.938.01-.013L16 5.426 14.25 7.25 16 10.526l-3 1.778V3H3v10h8.825l-.266.158L11 16l-8.85-1.55L0 1.676 4 .024l2.525 1.5L8.875.275l.74.286L10.2 0z"/>
            <path fill={fill} d="M3.95 11.125H7.7v.625H3.95v-.625zm4.9-3.275.525-.65c.375.3.75.5 1.225.5.375 0 .6-.15.6-.4 0-.225-.15-.35-.825-.525-.825-.225-1.35-.45-1.35-1.275v-.025c0-.75.6-1.25 1.424-1.25a2.448 2.448 0 0 1 1.526.525l-.475.7a1.905 1.905 0 0 0-1.05-.4c-.325 0-.525.15-.525.375 0 .275.175.375.875.55.825.225 1.3.525 1.3 1.25 0 .825-.625 1.3-1.5 1.3a2.88 2.88 0 0 1-1.75-.675zm-.8-3.55-.625 2.4-.7-2.4h-.7l-.7 2.4L4.7 4.3h-.975l1.2 4.15H5.7l.675-2.4.674 2.4h.776l1.2-4.15H8.05z"/>
        </svg>
    );
}

export default IconWebstorm;
